<template>
  <v-navigation-drawer app v-model="drawer" :mini-variant.sync="mini" hide-overlay stateless>
    <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title" style="display: flex; justify-content: center">
            <img v-if="mini" src="../assets/branding/favicon.png" height="100%" />
            <img v-else src="../assets/branding/logo.svg" height="100%" />
          </v-list-tile-title>
          <v-list-tile-action v-if="!mini">
            <v-btn icon @click.stop="mini = !mini">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <!-- <v-divider></v-divider> -->

    <v-list class="pt-0">
      <!-- Page principale -->


      <!-- Dashboard -->
      <!-- <v-list-tile to="/dashboard" v-if="id">
        <v-list-tile-action>
          <v-icon>dashboard</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Dashboard</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile> -->

      <!-- Mes actes -->
      <v-list-tile to="/acts" sub-item>
        <v-list-tile-action>
          <v-icon>assignment</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Mes demandes</v-list-tile-title>
      </v-list-tile>

      <!-- Demander une signification -->
      <v-list-tile :to="{ name: 'new_act' }">
        <v-list-tile-action>
          <v-icon>create_new_folder</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Déposer un acte</v-list-tile-title>
      </v-list-tile>


      <v-divider />

      <v-list-tile :to="{ name: 'advocate', params: { id: id }}" v-if="id">
        <v-list-tile-action>
          <v-icon>person</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>{{ completeName }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Signin -->
      <v-list-tile to="/signin" v-if="!id">
        <v-list-tile-action>
          <v-icon>account_circle</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Se connecter</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider />

      <!-- Aide -->
      <v-list-tile to="/help">
        <v-list-tile-action>
          <v-icon>help</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Aide</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NavBar",
  computed: {
    ...mapGetters("currentUser", ["id", "completeName"])
  },
  // TODO computed here for logged user
  data() {
    return {
      drawer: true,
      mini: true,
      right: null
    };
  }
};
</script>
